import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { HOME } from '../../../routes/paths';

const SharePointRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(HOME, { replace: true });
    }, [navigate]);

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default SharePointRedirect;
